import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { CheckItem } from "../../../../components/checkbox-block/checkbox-block.component";
import { ModalService } from "../../../../services/modal.service";
import {
	userPermissionList,
	rolePermissionList,
	virtualPosPermissionList,
	paymentLinksPermissionList,
	savedCardPermissionList,
	supportPermissionList,
	recurringPaymentPermissionList,
	refundPermissionList,
	paymentPermissionList,
	terminalsPermissionList,
	p2pPermissionList,
	infoPermissionList,
	paymentViewPermissionList,
	analyticsPermissionList,
} from "../../constants/permission-list";
import { RoleDataService } from "../../services/role-data.service";
import { CreateRoleDto, PermissionDto } from "../../models/role-models";
import { CheckboxUpdateService } from "../../../../services/checkbox-update.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { notSymbolValidator } from "../../../../validators/not-symbol.validator";
import { Subscription } from "rxjs";
import { CheckAllProps } from "src/app/components/checkbox-block/checkbox-model";

@Component({
	selector: "app-add-role-dialog",
	templateUrl: "./add-role-dialog.component.html",
	styleUrls: ["./add-role-dialog.component.scss"],
})
export class AddRoleDialogComponent implements OnInit, OnDestroy {
	@Output() roleAdded: EventEmitter<void> = new EventEmitter<void>();

	userPermissionList: CheckItem[] = [];
	rolePermissionList: CheckItem[] = [];
	virtualPosPermissionList: CheckItem[] = [];
	paymentLinksPermissionList: CheckItem[] = [];
	savedCardPermissionList: CheckItem[] = [];
	supportPermissionList: CheckItem[] = [];
	recurringPaymentPermissionList: CheckItem[] = [];
	refundPermissionList: CheckItem[] = [];
	paymentPermissionList: CheckItem[] = [];
	terminalsPermissionList: CheckItem[] = [];
	p2pPermissionList: CheckItem[] = [];
	infoPermissionList: CheckItem[] = [];
	paymentViewPermissionList: CheckItem[] = [];
	analyticsPermissionList: CheckItem[] = [];

	permissionList: CheckItem[][] = [];

	isSending = false;
	subs: Subscription[] = [];

	form!: FormGroup;

	constructor(
		private modalService: ModalService,
		private roleDataService: RoleDataService,
		private checkboxUpdateService: CheckboxUpdateService
	) {
		this.permissionList = [
			(this.userPermissionList = [...userPermissionList]),
			(this.rolePermissionList = [...rolePermissionList]),
			(this.virtualPosPermissionList = [...virtualPosPermissionList]),
			(this.paymentLinksPermissionList = [...paymentLinksPermissionList]),
			(this.savedCardPermissionList = [...savedCardPermissionList]),
			(this.supportPermissionList = [...supportPermissionList]),
			(this.recurringPaymentPermissionList = [...recurringPaymentPermissionList]),
			(this.refundPermissionList = [...refundPermissionList]),
			(this.paymentPermissionList = [...paymentPermissionList]),
			(this.terminalsPermissionList = [...terminalsPermissionList]),
			(this.p2pPermissionList = [...p2pPermissionList]),
			(this.infoPermissionList = [...infoPermissionList]),
			(this.paymentViewPermissionList = [...paymentViewPermissionList]),
			(this.analyticsPermissionList = [...analyticsPermissionList]),
		];
	}

	ngOnInit() {
		this.initForm();
		this.initModal();
	}

	initModal() {
		this.subs.push(
			this.modalService.isModalOpen$.subscribe({
				next: (res) => {
					if (!res) {
						this.permissionList.forEach((item) => {
							item.forEach((roleItem) => {
								roleItem.state = false;
							});
						});
					}
				},
			})
		);
	}

	initForm() {
		this.form = new FormGroup({
			roleName: new FormControl("", [Validators.required, notSymbolValidator()]),
		});
	}

	checkboxChange(checkItem: CheckItem) {
		const itemList = this.permissionList.find((el) => el.includes(checkItem));

		if (paymentLinksPermissionList?.includes(checkItem) && itemList && checkItem.id === itemList[0].id) {
			this.paymentPermissionList = [...this.paymentPermissionList];
			this.paymentPermissionList[0].state = true;
		}

		// if (checkItem.state === false && paymentLinksPermissionList?.includes(checkItem) && itemList && checkItem.id === itemList[0].id) {
		// 	this.paymentPermissionList = [...this.paymentPermissionList];
		// 	this.paymentPermissionList[0].state = false;
		// }

		if (
			(paymentLinksPermissionList.includes(checkItem) && itemList && checkItem.id === itemList[2].id) ||
			(paymentLinksPermissionList.includes(checkItem) && itemList && checkItem.id === itemList[1].id)
		) {
			this.virtualPosPermissionList = [...this.virtualPosPermissionList];
			this.virtualPosPermissionList[0].state = true;
			this.paymentViewPermissionList = [...this.paymentViewPermissionList];
			this.paymentViewPermissionList[0].state = true;
		}

		// if (
		// 	(checkItem.state === false && paymentLinksPermissionList.includes(checkItem) && itemList && checkItem.id === itemList[2].id) ||
		// 	(checkItem.state === false && paymentLinksPermissionList.includes(checkItem) && itemList && checkItem.id === itemList[1].id)
		// ) {
		// 	this.virtualPosPermissionList = [...this.virtualPosPermissionList];
		// 	this.virtualPosPermissionList[0].state = false;
		// 	this.paymentViewPermissionList = [...this.paymentViewPermissionList];
		// 	this.paymentViewPermissionList[0].state = false;
		// }

		if (itemList?.includes(checkItem) && checkItem !== itemList[0]) {
			itemList[0].state = true;
		}

		this.permissionList.forEach((item) => {
			item.forEach((roleItem) => {
				if (roleItem.id === checkItem.id) {
					roleItem.state = checkItem.state;
				}
			});
		});

		this.updateList();
	}

	checkboxAllChange(checkboxChangeProps: CheckAllProps) {
		this.permissionList.find((el) => el.includes(checkboxChangeProps.itemList[0]))?.forEach((item) => (item.state = checkboxChangeProps.state));
		if (checkboxChangeProps.state) {
			this.permissionList.find((el) => el.includes(checkboxChangeProps.itemList[0]))?.forEach((item) => this.checkboxChange(item));
		}
	}

	updateList() {
		this.userPermissionList = [...userPermissionList];
		this.rolePermissionList = [...rolePermissionList];
		this.virtualPosPermissionList = [...virtualPosPermissionList];
		this.paymentLinksPermissionList = [...paymentLinksPermissionList];
		this.savedCardPermissionList = [...savedCardPermissionList];
		this.supportPermissionList = [...supportPermissionList];
		this.recurringPaymentPermissionList = [...recurringPaymentPermissionList];
		this.refundPermissionList = [...refundPermissionList];
		this.paymentPermissionList = [...paymentPermissionList];
		this.terminalsPermissionList = [...terminalsPermissionList];
		this.p2pPermissionList = [...p2pPermissionList];
		this.infoPermissionList = [...infoPermissionList];
		this.paymentViewPermissionList = [...paymentViewPermissionList];
		this.analyticsPermissionList = [...analyticsPermissionList];
	}

	get roleNameFormatError() {
		return this.form.get("roleName")?.hasError("symbolNotValid");
	}

	get roleNameRequiredError() {
		return this.form.get("roleName")?.hasError("required");
	}

	closeModal() {
		this.modalService.closeModal();
	}

	saveRole() {
		if (this.form.invalid) {
			return;
		}

		this.isSending = true;

		let permission: PermissionDto[] = [];
		this.permissionList.forEach((item) => {
			item.forEach((roleItem) => {
				if (roleItem.state) {
					permission.push({ id: roleItem.id, name: roleItem.name });
				}
			});
		});

		const roleData: CreateRoleDto = {
			name: this.form.get("roleName")?.value,
			privileges: permission,
		};

		this.roleDataService.createRole(roleData).subscribe({
			complete: () => {
				this.isSending = false;
				this.roleAdded.emit();
				this.form.reset();
				this.permissionList.forEach((item) => {
					item.forEach((roleItem) => {
						roleItem.state = false;
					});
				});
			},
			error: () => {
				this.isSending = false;
			},
		});
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
	}
}
